import { Component, OnInit } from '@angular/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { OpeningStationService } from '../../service/opening-station/opening-station.service';
import { OpeningStation } from '../../class/opening-station';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-openings-stations',
  templateUrl: './openings-stations.component.html',
  styleUrls: ['./openings-stations.component.scss']
})
export class OpeningsStationsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public openingsStations: OpeningStation[];
    public selectOpeningStation: OpeningStation;
    public OpeningStationID: Number = 0;
    public modNew = false;
    public modView = false;
    public openOpeningStation = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public form3: FormGroup;
    public station_id_filter: AbstractControl;

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;
    public f4_station_id: AbstractControl;
    public f4_administrative_division: AbstractControl;
    public f4_export_filter: AbstractControl;

    public apiUrl = config.API_ROOT;

    public modExportDialog: boolean;

    public es: any;

    public exportOptions: SelectItem[];

    constructor(
        public openingStationService: OpeningStationService,
        public hasPermissionService: HasPermissionService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        fb: FormBuilder) {
            this.exportOptions = [
                {label: 'Excel', value: 'excel'},
            ];

            this.es = calendarES();

            this.form3 = fb.group({
                'station_id_filter': [''],
            });
            this.station_id_filter = this.form3.controls['station_id_filter'];

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
                'f4_station_id': [''],
                'f4_administrative_division': [''],
                'f4_employee_id': [''],
                'f4_type_filter': [''],
                'f4_export_filter': [''],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];
            this.f4_station_id = this.form4.controls['f4_station_id'];
            this.f4_administrative_division = this.form4.controls['f4_administrative_division'];
            this.f4_export_filter = this.form4.controls['f4_export_filter'];
            this.f4_export_filter.setValue('excel');

            this.modExportDialog = false;
        }

    ngOnInit() {
        //this.getOpeningsStation();
        this.page = 1;
        this.per_page = 10;
    }

    public loadOpeningsStationsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  event.sortField;
        } else {
            this.sort =  '-id';
        }
        this.getOpeningsStation(event.globalFilter);
    }

    public getOpeningsStation(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.openingStationService.getOpeningStation(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.openingsStations = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newOpeningStation() {
        this.modNew = !this.modNew;
        this.selectOpeningStation = null;
    }

    public savedOpeningStation(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectOpeningStation = null;
        this.modNew = false;
        this.getOpeningsStation();
    }

    public cancelOpeningStation (res) {
        this.selectOpeningStation = null;
        this.modNew = false;
        this.modView = false;
        this.getOpeningsStation();
    }

    public edit(openingStation: OpeningStation) {
        this.modNew = true;
        this.selectOpeningStation = openingStation;
        this.getOpeningsStation();
    }

    public view(openingStation: OpeningStation) {
        this.openOpeningStation = true;
        this.selectOpeningStation = openingStation;
        this.OpeningStationID = openingStation.id;
        this.modView = true;
    }

    public deleteDialog(openingStation: OpeningStation) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(openingStation);
            }
        });
    }

    public delete(openingStation: OpeningStation) {
        this.openingStationService.deleteOpeningStation(openingStation.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getOpeningsStation();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeOpeningStation(openingStation: OpeningStation) {
        this.putOpeningStation(openingStation);
    }

    public putOpeningStation(values: OpeningStation) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.openingStationService.updateOpeningStation(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public filterStation (values) {
        const filters = [];
        if (values.station_id_filter) {
            filters.push({'key': 'station_id-lk', 'value': values.station_id_filter.id});
        }
        this.getOpeningsStation(undefined, filters);
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportPdf(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        window.open(this.apiUrl + '/openings-stations/pdf?created_at-min=' + f4_date_start + '&created_at-max=' + f4_date_end +
        '&token=' + localStorage.getItem('token') + '&_page=1&_limit=100000', '_blank');
    }

    public exportReport(values) {
        if (values.f4_export_filter === 'pdf') {
            this.exportReportPdf(values);
        } else {
            this.exportReportExcel(values);
        }
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/openings-stations/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=-id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        if (values.f4_administrative_division) {
            url = url + 'administrative_division=' + values.f4_administrative_division + '&';
        }

        if (values.f4_type_filter !== 'all' && values.f4_type_filter !== '') {
            url = url + 'status-in=' + values.f4_type_filter + '&';
        }

        window.open(url, '_blank');
    }    
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/opening-stations/openings-stations.component.ts